const getters = {
    sidebar: state => state.app.sidebar,
    language: state => state.app.language,
    size: state => state.app.size,
    instagramScores: state => state.scores.instagram,
    tiktokScores: state => state.scores.tiktok,
    device: state => state.app.device,
    userId: state => state.user.id,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    email: state => state.user.email,
    name: state => state.user.name,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    permissions: state => state.user.permissions,
    permission_routes: state => state.permission.routes,
    addRoutes: state => state.permission.addRoutes,
};

export default getters;
